"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplicationComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _application = require("./application.routes");

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var angular = require("angular");
var debug = require("debug")("fifi:app");
var uiRouter = require("angular-ui-router");

var ApplicationComponent = exports.ApplicationComponent = function () {

  /*@ngInject*/
  function ApplicationComponent(Auth, $rootScope, $http, stripe, $state, $stateParams, $document, Applications, Fake, EnvironmentConfig, Cars) {
    _classCallCheck(this, ApplicationComponent);

    this.preventSubmit = false;

    console.log("APPCOMP");
    this.loaded = false;
    var that = this;
    debug("Reached ApplicationComponent");
    debug(EnvironmentConfig);
    debug(this.settings);
    debug($stateParams);
    this._stripe = stripe;
    this._$state = $state;
    this._$http = $http;
    this._$document = $document;
    this._Auth = Auth;

    this._Applications = Applications;
    this._Cars = Cars;

    $rootScope.$$listeners.$stateChangeStart = [];
    $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState) {
      debug("stateChangeStart");
      debug(fromState.name, toState.name);
      that.error = "";
      if (fromState.name == "application.complete" && toState.name == "application.review") {
        event.preventDefault();
        that.resetStatus();
        that.resetPayment();
        that.application = {};
        that._$state.go("application.contact");
      }
    });

    this.preventPayment = false;

    this.steps = {
      contactForm: {
        next: "application.mailing",
        status: true
      },
      mailingForm: {
        next: "application.beach",
        status: false
      },
      paymentForm: {
        next: "application.review",
        status: false
      },
      agreementForm: {
        next: "application.payment",
        status: false
      },
      beachForm: {
        next: "application.vehicle",
        status: false
      },
      vehicleForm: {
        next: "application.agreement",
        status: false
      },
      review: {
        status: false
      },
      complete: {
        status: false
      }
    };

    this.returnData = {};

    this.topLocation = 40;
    this.scrollDuration = 800;

    this.error = null;

    this.makeList = [];
    this.modelList = [];

    this.yearStart = 1959;
    this.today = new Date();
    this.yearEnd = this.today.getYear() + 1900 + 1;
    this.years = [];


    this.communityConflict = false;
    this.communityWarning = "";

    if ($stateParams.homeownerApp) {
      this.application = {};
      this.application = angular.copy($stateParams.homeownerApp);
    } else if (EnvironmentConfig.environment == "development") {
      this.application = {};
      this.application = Fake.fakeApp();
      this.application.vehicle.make = null;
      this.application.vehicle.model = null;
      this.application.vehicle.year = null;
    } else {
      this.application = {};
    }

    this.payment = {};

    this.seqArray(this.yearStart, this.yearEnd, this.years, false);


    this.checkState();
  }

  _createClass(ApplicationComponent, [{
    key: "$onInit",
    value: function $onInit() {
      console.log("testInit");
      if (!this.settings.enableMainForm && !this._Auth.isAdminSync()) {
        console.log("going places");
        this._$state.go("main");
      } else {
        this.loaded = true;
      }
    }
  }, {
    key: "fillBilling",
    value: function fillBilling() {
      this.payment.address_line1 = this.application.address.line1;
      this.payment.address_line2 = this.application.address.line2;
      this.payment.address_city = this.application.address.city;
      this.payment.address_state = this.application.address.state;
      this.payment.address_zip = this.application.address.zip;
    }
  }, {
    key: "submitForm",
    value: function submitForm(form) {
      debug("test6:", form);

      if (form.$name == "paymentForm") {
        return this.getToken();
      }
      debug(form.$name);
      this.steps[form.$name].status = true;
      debug("Next: ", this.steps[form.$name].next);
      this._$state.go(this.steps[form.$name].next);
      this._$document.scrollTop(this.topLocation, this.scrollDuration);
    }
  }, {
    key: "startApp",
    value: function startApp() {
      this.resetStatus();
      this.resetPayment();
      this.application = {};
      this._$state.go("main");
    }
  }, {
    key: "submitApplication",
    value: function submitApplication() {
      var _this = this;

      if (!this.application.name.first || !this.application.name.last) {
        this.error = "You must enter your full name.";
        return;
      } else if (!this.application.contact.email || !this.application.contact.primaryPhone) {
        this.error = "You must enter both an email address and phone number.";
        return;
      } else if (!this.application.address.line1 || !this.application.address.city || !this.application.address.state || !this.application.address.zip) {
        this.error = "You must enter a proper mailing address.";
        return;
      } else if (!this.application.beach.community || !this.application.beach.type) {
        this.error = "You must enter both your community and type of property.";
        return;
      }

      this.preventSubmit = true;

      debug(this.application);

      this._Applications.save(this.application).then(function (response) {
        _this.steps.review.status = true;
        _this.error = null;
        _this.returnData = response;
        _this._$state.go("application.complete");
        _this._$document.scrollTop(_this.topLocation, _this.scrollDuration);
        _this.steps.complete.status = true;
        _this.application = {};
        _this.preventSubmit = false;
      }, function (err) {
        console.log(err);
        _this.error = err.data.message;
        if (!err.data.message) {
          _this.error = "Please check all information and try again.";
        }
        _this.preventSubmit = false;
      });
    }
  }, {
    key: "updateVehicleInfo",
    value: function updateVehicleInfo() {
      if (this.application.vehicle.raw) {
        this.application.vehicle.model = this.application.vehicle.raw.model;
        this.application.vehicle.size = this.application.vehicle.raw.oversized ? "Oversized" : "Normal";
      }
    }
  }, {
    key: "updateCars",
    value: function updateCars(mode) {
      var _this2 = this;

      if (mode == "year") {
        this.modelList = [];
        this.makeList = [];
        this.application.vehicle.make = null;
        this.application.vehicle.model = null;
      }
      this._Cars.getCarList(this.application.vehicle.year, this.application.vehicle.make).then(function (response) {
        if (mode === "year") {
          _this2.makeList = response;
          _this2.modelList = [];
        } else {
          _this2.modelList = response;
          _this2.modelList.push({ model: "Other", oversized: false });
        }
      });
    }
  }, {
    key: "resetStatus",
    value: function resetStatus() {
      for (var prop in this.steps) {
        if (prop != "contactForm") {
          this.steps[prop].status = false;
        }
      }
    }
  }, {
    key: "checkCommunity",
    value: function checkCommunity() {
      var beach = this.application.beach.community;
      var type = this.application.beach.type;
      var obOverride = this.application.obOverride;
      var westLot = beach == "SV" || beach == "PK";
      var obHO = beach == "OB" && type == "Homeowner";
      var saHO = beach == "SA" && type == "Homeowner";
      var misc = !westLot && !obHO && !saHO;

      this.preventPayment = false;
      if (westLot && this.settings.westFull) {
        debug("West Full");
        this.preventPayment = true;
      } else if (obHO && this.settings.obhoFull) {
        this.preventPayment = true;
        debug("OBHO Full");
      } else if (this.settings.mainFull && misc) {
        this.preventPayment = true;
        debug("Main Full");
      }

      if (beach == "OB" && type == "Homeowner" && !obOverride) {
        this.communityWarning = "This application is not the Ocean Beach\n        homeowner application.  This application is for other communities,\n        businesses, and for additional parking spots.\n        The Ocean Beach homeowner applications will be available online at a later date.\n        You will recieve an application ID via e-mail to allow you to complete the application on that date.";
        this.communityConflict = true;
      } else if (beach == "SA" && type == "Homeowner") {
        this.communityWarning = "This application is not the Saltaire\n        homeowner application.  This application is for other communities,\n        businesses, and for additional parking spots.\n        The Saltaire homeowner applications will be available online at a later date. You will recieve an application ID via e-mail to allow you to complete the application on that date.";
        this.communityConflict = true;
      } else {
        this.communityConflict = false;
      }
    }
  }, {
    key: "checkState",
    value: function checkState() {
      debug("Check State");
      if (this._$state.current.name != "application.contact" && !this.application.address) {
        debug("Contact is empty!");
        this._$state.go("application.contact");
      }
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var _this3 = this;

      if (this.application.charge || this.preventPayment) {
        return this._$state.go("application.review");
      }

      return this._stripe.card.createToken(this.payment).then(function (response) {
        _this3.error = null;
        debug("token created for card ending in " + response.card.last4);

        _this3.payment.number = void 0;
        _this3.payment.cvc = void 0;
        _this3.payment.exp_month = void 0;
        _this3.payment.exp_year = void 0;
        _this3.payment.token = response.id;
        debug(response);


        _this3.application.ip = response.client_ip;

        _this3.application.charge = {
          token: response.id,
          cardholder: response.card.name,
          billing: {
            line1: response.card.address_line1,
            line2: response.card.address_line2,
            city: response.card.address_city,
            state: response.card.address_state,
            zip: response.card.address_zip
          },
          cardId: response.card.id,
          last4: response.card.last4,
          brand: response.card.brand
        };
        _this3.steps.paymentForm.status = true;
        _this3._$state.go("application.review");
        _this3._$document.scrollTop(_this3.topLocation, _this3.scrollDuration);
      }).catch(function (err) {
        if (err.type && /^Stripe/.test(err.type)) {
          console.log("Stripe error: ", err.message);
          _this3.error = err.message;
        } else {
          console.log("Other error occurred, possibly with your API", err.message);
          _this3.error = err.message;
        }
      });
    }
  }, {
    key: "resetPayment",
    value: function resetPayment() {
      this.application.charge = null;
      this.payment = {};
    }
  }, {
    key: "calculatePrice",
    value: function calculatePrice() {
      this.checkCommunity();
      var standardPrice = void 0;
      if (this.application.beach.community == "OB" && this.application.beach.type == "Homeowner") {
        standardPrice = this.settings.obhoPrice;
      } else if (this.application.beach.community == "SA" && this.application.beach.type == "Homeowner") {
        standardPrice = this.settings.sahoPrice;
      } else {
        standardPrice = this.settings.miscPrice;
      }
      this.price = {
        standard: standardPrice,
        oversizedFee: 0,
        processingFee: 0,
        total: 0
      };
      if (this.application.vehicle.size === "Oversized") {
        this.price.oversizedFee = this.settings.oversizedFee;
      }
      this.price.processingFee = (this.price.standard + this.price.oversizedFee) * this.settings.processingFee;
      this.price.total = this.price.standard + this.price.oversizedFee + this.price.processingFee;
      return this.price;
    }
  }, {
    key: "seqArray",
    value: function seqArray(start, end, array, dir) {
      for (var i = end; i > start; i--) {
        if (dir) {
          array.unshift(i);
        } else {
          array.push(i);
        }
      }
      return array;
    }
  }]);

  return ApplicationComponent;
}();

exports.default = angular.module("parkingformApp.application", [uiRouter]).config(_application2.default).component("application", {
  template: require("./application.html"),
  controller: ApplicationComponent,
  controllerAs: "form",
  bindings: {
    settings: "<"
  }
}).name;


// WEBPACK FOOTER //
// ./client/app/application/application.component.js